import React, { useEffect, useState, useRef } from "react";
import { Loginwrapper } from "../style";
import Input from "../../ui/Input";
import Button from "../../ui/Button";
import OtpInput from "../../OtpInput/OtpInput";
import imgLogin from '../../../images/loginImg.jpg';
import { getStorage, isEmpty, isNumber, setStorage } from "../../../Utils/common";
import { Link, useNavigate } from "react-router-dom";
import { sendotpForLogin, verifyotpForLogin, ckeckEligibility } from "../../../Utils/api";
import Alert from "../../ui/Alert";
import Captcha, { getCaptchaValidation } from "../../ui/Captcha";
import MobileInput from "../../OtpInput/MobileInput";
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GiPayMoney, GiTakeMyMoney } from "react-icons/gi";
import { VscCombine } from "react-icons/vsc";
import { BsFillGrid1X2Fill } from "react-icons/bs";
import { AiOutlineFileDone } from "react-icons/ai";
import { VscOpenPreview } from "react-icons/vsc";
import { IoMdDoneAll } from "react-icons/io";
import process_line from "../../../images/process_line.svg";
import { APP_NAME, NBFC_NAME } from "../../../Utils/constant";
import { getApplicantGeolocation } from "../../../Utils/geolocation";

function Login() {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [screen, setScreen] = useState("getOtp");
  const [seconds, setSeconds] = useState(0);
  const [mobile, setMobile] = useState(["", "", "", "", "", "", "", "", "", ""]);
  const [mobileError, setMobileError] = useState("");
  const [loading, setLoading] = useState(false);
  const [accept, setAccept] = useState(false);
  const [acceptError, setAcceptError] = useState("");
  const [captchaValue, setCaptchaValue] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [captchaCode, setCaptchaCode] = useState("");
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [message, setMessage] = useState({});
  const [responce, setResponce] = useState({});
  const inputRefs = useRef([]);
  const captchaRef = useRef(null);
  const navigate = useNavigate();
  const [showMore, setShowMore] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Extract UTM parameters from the URL
  const getUtmParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
      utm_term: params.get("utm_term") || "",
      utm_content: params.get("utm_content") || ""
    };
  };



  useEffect(() => {
    if (screen === "getOtp") return;
    const timer = setInterval(() => {
      if (seconds === 0) {
        clearInterval(timer);
      } else {
        setSeconds(seconds - 1);
      }
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [seconds]);

  useEffect(() => {
    if (!captchaCode) return;
    const result = getCaptchaValidation(captchaValue, captchaCode);
    setIsCaptchaValid(result.valid);
    setCaptchaError(result.message);
  }, [captchaCode, captchaValue]);

  const onChanges = (e, type) => {
    const { name, value } = e.target;

    if (type === "sendOtp") {
      if (!isNumber(value) && !isEmpty(value)) return;
      setMobile(value);
      setMobileError("");
    }
  };

  const sendOtp = async () => {
    let mobileNumber = mobile.join("");
    if (mobileNumber.length < 10) {
      setMobileError("The Mobile field must be at least 10 characters in length.");
      return;
    }
    if (!accept) {
      setAcceptError("Please check the checkbox to accept our terms and conditions");
      return;
    } else {
      setAcceptError(""); 
    }

    const captchaResult = getCaptchaValidation(captchaValue, captchaCode);
    if (!captchaResult.valid) {
      setCaptchaError(captchaResult.message);
      setIsCaptchaValid(false);
      return;
    }
    setCaptchaError("");
    setIsCaptchaValid(true);

    // Get UTM parameters from the URL
    const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } = getUtmParams();

    setLoading(true);
    const geo = await getApplicantGeolocation();
    if (!geo.ok) {
      setLoading(false);
      setMessage({ type: 'error', msg: geo.error });
      return;
    }

    const param = {
      mobile: mobileNumber,
      event_name: "send_otp",
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
      geo_lat: geo.lat,
      geo_long: geo.long,
    };

    sendotpForLogin(param).then(resp => {
      setLoading(false);
      if (resp?.data?.Status === 1) {
        setResponce(resp?.data);
        setStorage("mobile", mobileNumber);
        setStorage("cust_profile_id", resp?.data?.Data?.cust_profile_id);
        setScreen("otpScreen");
        setSeconds(30);
        setMessage({ type: 'success', msg: resp?.data?.Message, place: "globle" });
      } else {
        setMobile(["", "", "", "", "", "", "", "", "", ""]); 
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus(); 
        }
        captchaRef.current?.refresh();
        let msg = resp?.data?.Message || resp?.data?.error || "An error occurred";
        setMessage({ type: 'error', msg: msg });
      }
    });
  };

  const resendOtp = () => {
    const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } = getUtmParams();

    const param = {
      profile_id: getStorage("cust_profile_id"),
      event_name: "resend_otp",
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content
    };

    setLoading(true);
    sendotpForLogin(param).then(resp => {
      setLoading(false);
      if (resp?.data?.Status === 1) {
        setResponce(resp?.data);
        setScreen("otpScreen");
        setSeconds(30);
        setMessage({ type: 'success', msg: resp?.data?.Message, place: "globle" });
      } else {
        setMobile(["", "", "", "", "", "", "", "", "", ""]); 
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus(); 
        }
        let msg = resp?.data?.Message || resp?.data?.error || "An error occurred";
        setMessage({ type: 'error', msg: msg });
      }
    });
  };

  const verifyOTP = async () => {
    let otpNumber = otp.join("");
  
    if (otpNumber.length !== 4) {
      setMessage({ type: 'error', msg: "Please enter 4 digits OTP" });
      return;
    }
  
    const param = {
      event_name: "otp_verify",
      profile_id: getStorage("cust_profile_id"),
      otp: otpNumber,
    };
  
    setLoading(true);
    try {
      const resp = await verifyotpForLogin(param);
  
      setLoading(false);
  
      if (resp?.data?.Status === 1) {
        setResponce(resp?.data);
        setStorage("next_step", resp?.data?.Data?.next_step);
        setStorage("token", resp?.data?.Data?.app_login_token);
        setMessage({ type: 'success', msg: resp?.data?.Message, place: "globle" });

        // Check application status
        const profileData = resp?.data?.Data?.profile_details;
        const applicationStatus = profileData?.application_submitted;
        const leadId = profileData?.lead_id;

        if (applicationStatus === 1 || applicationStatus === "1") {
          // Application already submitted, redirect to completion page
          setStorage("lead_id", leadId);
          setStorage("application_status", "submitted");
          setMessage({ 
            type: 'info', 
            msg: `Your application is already submitted! Application ID: ${leadId || 'N/A'}. Redirecting to application status...`, 
            place: "global" 
          });
          setTimeout(() => {
            navigate('/my-dashboard/application-complete');
          }, 2000);
          return;
        }

        if (resp?.data?.Data?.eligibility_status === 1) {
          setStorage("eligibility", 1); // Store eligibility as 1 if eligible
        } else {
          setStorage("eligibility", 0); // Store eligibility as 0 if not eligible
        }
    
        // Navigate based on eligibility
        if (getStorage('eligibility') === 1) {
          console.log("Navigating to /my-dashboard/eligibility");
          navigate('/my-dashboard/eligibility');
        } else {
          console.log("Navigating to /my-dashboard");
          navigate('/my-dashboard');
        }
      } else {
        setOtp(["", "", "", ""]);
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
        let msg = resp?.data?.Message || resp?.data?.error || "An error occurred";
        setMessage({ type: 'error', msg: msg });
      }
    } catch (err) {
      setLoading(false);
      setMessage({ type: 'error', msg: "Error verifying OTP" });
      console.error("OTP Verification Error:", err);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      verifyOTP();
    }
  };

  useEffect(() => {
    if (isEmpty(message)) return;
    const timer = setTimeout(() => {
      setMessage({});
    }, 5000);

    return () => {
      clearTimeout(timer);
    };
  }, [message]);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <>
    
    <Loginwrapper className="flex justify-center">
      <div className="right">
        <div className="form">
          <Alert setMessage={setMessage} message={message} />
          <h2>Apply for a Personal Loan</h2>
          {screen === "getOtp" ? (
            <>
              <p>Enter your 10 digit mobile number to get started</p>
              <div className="otpBox">
              <MobileInput
              name="mobile"
              setOtp={setMobile}
              otp={mobile}
              isDisable={false}
              error={mobileError}
              onChange={(e) => onChanges(e, "sendOtp")}
              placeholder="*"
              onKeyDown={handleKeyDown}
              inputRefs={inputRefs}
            />

              </div>
              <div className="flex confirm" style={{ fontSize: "14px", fontWeight: "500", textAlign: "justify", marginBottom: "20px" }}>
                <input
                  style={{ height: "18px", width: "18px", marginRight: "12px", accentColor: "#4A7C59" }}
                  name="radio"
                  type="radio"
                  checked={accept}
                  onChange={() => {
                    setAccept(!accept);
                    setAcceptError("");
                  }}
                />
                <p style={{ fontSize: "14px", lineHeight: "20px", color: "#374151" }}>
                  By selecting this checkbox, I authorize the receipt of digital communications
                  {showMore ? (
                    <span>
                      , such as phone calls, SMS, emails, and WhatsApp messages, at the phone number, email address, and app I have provided from {APP_NAME}. Furthermore, I acknowledge that I have reviewed and accept the , <Link to="/terms-condition" style={{ color: '#4A7C59', textDecoration: 'none', fontWeight: '600' }}>Terms and Conditions</Link> and <Link to="/privacy-policy" style={{ color: '#4A7C59', textDecoration: 'none', fontWeight: '600' }}> Privacy Policy</Link>.
                    </span>
                  ) : (
                    <span>
                      <button onClick={() => setShowMore(true)} style={{ cursor: 'pointer', border: 'none', background: 'none', color: '#4A7C59', textDecoration: 'none', fontWeight: '600' }}>read more</button>
                    </span>
                  )}
                </p>
              </div>
              {acceptError && <p style={{ color: 'red', fontSize: '12px' }}>{acceptError}</p>}
              <Captcha
                ref={captchaRef}
                value={captchaValue}
                error={captchaError}
                onCodeChange={setCaptchaCode}
                onChange={(e) => setCaptchaValue(e.target.value)}
              />
              <div className="button">
                <Button title="Get OTP" onClick={sendOtp} loading={loading} disabled={!isCaptchaValid} />
              </div>
            </>
          ) : (
            <>
             
            
              <p style={{ fontSize: "16px", fontWeight: "600", marginBottom: "20px", color: "#4A7C59" }}>
                Mobile number : ******{(getStorage("mobile") && getStorage("mobile").length >= 10) ? getStorage("mobile").slice(-4) : 'N/A'}
              </p>
              <p style={{ fontSize: "16px", marginBottom: "20px" }}>Please enter the OTP to unlock your next step.</p>
              <div className="otpBox">
                <OtpInput
                  type="text"
                  setOtp={setOtp}
                  otp={otp}
                  isDisable={false}
                  placeholder="*"
                  onKeyDown={handleKeyDown}
                  inputRefs={inputRefs}
                />
              </div>
              <div className="button">
                <Button title="Verify OTP" onClick={verifyOTP} loading={loading} />
              </div>
              <div className="resend">
                {seconds > 0 ? (
                  <p className="none">
                    Didn't receive the OTP? <FontAwesomeIcon icon={faClock} style={{ marginRight: '5px', marginLeft: '5px', color: 'red' }} /> <span style={{ color: "red", fontWeight: 600 }}>00:{seconds}s</span>
                  </p>
                ) : (
                  <button
                    onClick={!loading ? resendOtp : () => {}}
                    style={{
                      backgroundColor: 'transparent',
                      border: '2px solid #4A7C59',
                      color: '#4A7C59',
                      padding: '12px 20px',
                      borderRadius: '25px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontFamily: 'Lato, sans-serif',
                      fontWeight: '600',
                      transition: 'all 0.3s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#4A7C59';
                      e.target.style.color = '#fff';
                      e.target.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                      e.target.style.color = '#4A7C59';
                      e.target.style.transform = 'translateY(0)';
                    }}
                  >
                    Resend OTP
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </Loginwrapper>
    {/* <div className="services_page_section"  data-aos="zoom-in">
          <div className="services_row">
            <Link to="/instant-loan">
              <div className="services_item">
                <div className="services_icon_container">
                  <GiPayMoney className="services_icon" />
                </div>
                <div className="services_content">
                  <div className="services_title">
                    <h4>Instant Loan</h4>
                  </div>
                  <p>
                    We offer instant loans to help you tackle unexpected
                    financial needs swiftly and efficiently. 
                  </p>
                </div>
              </div>
            </Link>
            <Link to="/short-term-loan">
              <div className="services_item">
                <div className="services_icon_container">
                  <GiTakeMyMoney className="services_icon" />
                </div>
                <div className="services_content">
                  <div className="services_title">
                    <h4>Short Loan</h4>
                  </div>
                  <p>
                    Discover the convenience of short loans at {APP_NAME},
                    designed to meet your immediate financial needs with ease.
                  
                  </p>
                </div>
              </div>
            </Link>
            <Link to="/debt-consolidation-loan">
              <div className="services_item">
                <div className="services_icon_container">
                  <VscCombine className="services_icon" />
                </div>
                <div className="services_content">
                  <div className="services_title">
                    <h4>Debt Consolidation</h4>
                  </div>
                  <p>
                    Take control of your finances with our debt consolidation
                    services. Consolidate multiple debts into one manageable
                    payment 
                  </p>
                </div>
              </div>
            </Link>
            </div>
            </div> */}

            {/* <div className="general_working">
            <div className="title_section">
              <p className="sub_title flex flex-center justify-center">
                <span>
                  <BsFillGrid1X2Fill
                    className="mr10"
                    style={{ marginBottom: "-2px" }}
                  />
                </span>
                <span>RISKS</span>
              </p>

              <h2 className="mt20 full-width text-center">
                A disclaimer before you <span>Apply</span>
              </h2>
            </div>
            <div className="process_card_area mt50">
              <div className="process_line">
                <img src={process_line} alt="" />
              </div>
              <div className="process_row">
                <div className="process_card">
                  <div className="process_card_icon flex flex-center justify-center mb20">
                    <AiOutlineFileDone className="process_icon" />
                  </div>
                  <div className="process_card_number">01</div>
                  <h2 className="mb10">Relatively high interest rate</h2>
                  <p className="full-width text-center">
The rates are somewhat higher as compared to long-term loans like automobile loans from banks.
                  </p>
                </div>
                <div className="process_card">
                  <div className="process_card_icon flex flex-center justify-center mb20">
                    <VscOpenPreview className="process_icon" />
                  </div>
                  <div className="process_card_number">02</div>
                  <h2 className="mb10">Residents only</h2>
                  <p className="full-width text-center">
                    We greatly value the trust of our Indian customers and are committed to providing services that prioritize your unique requirements.
                  </p>
                </div>
                <div className="process_card">
                  <div className="process_card_icon flex flex-center justify-center mb20">
                    <IoMdDoneAll className="process_icon" />
                  </div>
                  <div className="process_card_number">03</div>
                  <h2 className="mb10">Salary loans</h2>
                  <p className="full-width text-center">
This is short term loan service only for salaried individuals with a salary above INR 35000/-.
                  </p>
                </div>
                
              </div>
            </div>
          </div>

          <div className="text_content_wrapper">
          <div className="text_content" style={{ width: "95%" }}>
            <h1 className="page_title mt30 mb50">Terms and Conditions</h1>
            <div className="flex flex-center content_row">
              <div className="content_item" style={{ maxWidth: "90%" }}>
                <p>
                  Welcome to the {APP_NAME} website, operated by {NBFC_NAME} ("we", "us", "our"). By accessing or using
                  our website ("Site") and services ("Services"), you agree to
                  be bound by the following terms and conditions.
                </p>
                <a href="/terms-condition" style={{color:"#0063B9", marginLeft:"10px"}}>Read more</a>
              </div>
            </div>
          </div>
          </div> */}

          <br/>
          <div style={{
            background: 'linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)',
            padding: '40px',
            borderRadius: '20px',
            marginTop: '40px',
            border: '2px solid rgba(74, 124, 89, 0.1)',
            boxShadow: '0 10px 30px rgba(74, 124, 89, 0.1)',
            maxWidth: '100%',
            width: '100%',
            boxSizing: 'border-box'
          }}>
            <h2 style={{
              color: '#4A7C59',
              fontSize: '28px',
              fontWeight: '700',
              marginBottom: '25px',
              textAlign: 'center',
              borderBottom: '3px solid #4A7C59',
              paddingBottom: '10px'
            }}>Rates and Fees</h2>
            
            <div style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
              gap: '20px',
              marginBottom: '30px'
            }}>
              <div style={{
                background: 'white',
                padding: '20px',
                borderRadius: '15px',
                border: '2px solid rgba(74, 124, 89, 0.1)',
                textAlign: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  color: '#4A7C59',
                  marginBottom: '10px',
                  fontSize: '18px',
                  fontWeight: '600'
                }}>Monthly Interest Rate</div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: '#2D5A27'
                }}>2.9166%</div>
              </div>
              
              <div style={{
                background: 'white',
                padding: '20px',
                borderRadius: '15px',
                border: '2px solid rgba(74, 124, 89, 0.1)',
                textAlign: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  color: '#4A7C59',
                  marginBottom: '10px',
                  fontSize: '18px',
                  fontWeight: '600'
                }}>Annual Percentage Rate</div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: '#2D5A27'
                }}>35% (Fixed)</div>
              </div>
              
              <div style={{
                background: 'white',
                padding: '20px',
                borderRadius: '15px',
                border: '2px solid rgba(74, 124, 89, 0.1)',
                textAlign: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  color: '#4A7C59',
                  marginBottom: '10px',
                  fontSize: '18px',
                  fontWeight: '600'
                }}>Repayment Period</div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: '#2D5A27'
                }}>1 - 3 Years</div>
              </div>
              
              <div style={{
                background: 'white',
                padding: '20px',
                borderRadius: '15px',
                border: '2px solid rgba(74, 124, 89, 0.1)',
                textAlign: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  color: '#4A7C59',
                  marginBottom: '10px',
                  fontSize: '18px',
                  fontWeight: '600'
                }}>Loan Amount</div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: '#2D5A27'
                }}>₹10,000 - ₹1,00,000</div>
              </div>
            </div>
            
            <h3 style={{
              color: '#4A7C59',
              fontSize: '24px',
              fontWeight: '700',
              marginBottom: '20px',
              textAlign: 'center'
            }}>Representative Example</h3>
            
            <div style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
              gap: '20px',
              marginBottom: '30px'
            }}>
              <div style={{
                background: 'white',
                padding: '20px',
                borderRadius: '15px',
                border: '2px solid rgba(74, 124, 89, 0.1)',
                textAlign: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  color: '#4A7C59',
                  marginBottom: '10px',
                  fontSize: '18px',
                  fontWeight: '600'
                }}>Loan Amount</div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: '#2D5A27'
                }}>₹50,000</div>
              </div>
              
              <div style={{
                background: 'white',
                padding: '20px',
                borderRadius: '15px',
                border: '2px solid rgba(74, 124, 89, 0.1)',
                textAlign: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  color: '#4A7C59',
                  marginBottom: '10px',
                  fontSize: '18px',
                  fontWeight: '600'
                }}>APR</div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: '#2D5A27'
                }}>35%</div>
              </div>
              
              <div style={{
                background: 'white',
                padding: '20px',
                borderRadius: '15px',
                border: '2px solid rgba(74, 124, 89, 0.1)',
                textAlign: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  color: '#4A7C59',
                  marginBottom: '10px',
                  fontSize: '18px',
                  fontWeight: '600'
                }}>Tenure</div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: '#2D5A27'
                }}>12 Months</div>
              </div>
              
              <div style={{
                background: 'white',
                padding: '20px',
                borderRadius: '15px',
                border: '2px solid rgba(74, 124, 89, 0.1)',
                textAlign: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  color: '#4A7C59',
                  marginBottom: '10px',
                  fontSize: '18px',
                  fontWeight: '600'
                }}>Processing Fee</div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: '#2D5A27'
                }}>₹1,000</div>
              </div>
              
              <div style={{
                background: 'white',
                padding: '20px',
                borderRadius: '15px',
                border: '2px solid rgba(74, 124, 89, 0.1)',
                textAlign: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  color: '#4A7C59',
                  marginBottom: '10px',
                  fontSize: '18px',
                  fontWeight: '600'
                }}>GST on Processing Fee</div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: '#2D5A27'
                }}>₹180</div>
              </div>
              
              <div style={{
                background: 'white',
                padding: '20px',
                borderRadius: '15px',
                border: '2px solid rgba(74, 124, 89, 0.1)',
                textAlign: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  color: '#4A7C59',
                  marginBottom: '10px',
                  fontSize: '18px',
                  fontWeight: '600'
                }}>Amount Disbursed</div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: '#2D5A27'
                }}>₹48,820</div>
              </div>
              
              <div style={{
                background: 'white',
                padding: '20px',
                borderRadius: '15px',
                border: '2px solid rgba(74, 124, 89, 0.1)',
                textAlign: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  color: '#4A7C59',
                  marginBottom: '10px',
                  fontSize: '18px',
                  fontWeight: '600'
                }}>EMI</div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: '#2D5A27'
                }}>₹4,998</div>
              </div>
              
              <div style={{
                background: 'white',
                padding: '20px',
                borderRadius: '15px',
                border: '2px solid rgba(74, 124, 89, 0.1)',
                textAlign: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  color: '#4A7C59',
                  marginBottom: '10px',
                  fontSize: '18px',
                  fontWeight: '600'
                }}>Total Repayment Amount</div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: '#2D5A27'
                }}>₹59,978</div>
              </div>
              
              <div style={{
                background: 'white',
                padding: '20px',
                borderRadius: '15px',
                border: '2px solid rgba(74, 124, 89, 0.1)',
                textAlign: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  color: '#4A7C59',
                  marginBottom: '10px',
                  fontSize: '18px',
                  fontWeight: '600'
                }}>Total Interest</div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: '#2D5A27'
                }}>₹9,978</div>
              </div>
            </div>
          </div>
    </>
  );
}

export default Login;
